module.exports = __webpack_public_path__ + "static/img/test-image-2@3x.90d1efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduction/test-image-2@3x.png
// module id = Dxwj
// module chunks = 6